import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { setRateUnitOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getRateUnitOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const rateUnitsResponse: IOptionsResponse = yield call([optionsService, optionsService.getRateUnitsOptions])
    const { entity } = rateUnitsResponse
    yield put(setRateUnitOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRateUnitOptions() error: ${e}`))
  }
}

export function* getRateUnitOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getRateUnitOptions)
}
